// @ts-nocheck
/* Verbatim port of v1 components/partials/dashboard/company/DefaultUserForm.js */
import React from 'react';
import { Card as ShadCard } from '@/components/ui/card';
import { Button as _ShadButton } from '@/components/ui/button';
import { CalendarDateInput } from '@/components/ui/calendar-inputs';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

const _cx = (...args: any[]) => args.filter(Boolean).join(' ');
const Container: any = ({ fluid, className, children, ...props }: any) => (
  <div className={_cx(fluid ? 'container-fluid' : 'container', className)} {...props}>
    {children}
  </div>
);
const Row: any = ({ className, children, ...props }: any) => (
  <div className={_cx('row', className)} {...props}>
    {children}
  </div>
);
const _colCls = ({ xs, sm, md, lg, xl }: any) => {
  const parts = [];
  if (md) parts.push(`col-md-${md}`);
  if (lg) parts.push(`col-lg-${lg}`);
  if (xl) parts.push(`col-xl-${xl}`);
  if (sm) parts.push(`col-sm-${sm}`);
  if (xs) parts.push(`col-${xs}`);
  if (!parts.length) parts.push('col');
  return parts.join(' ');
};
const Col: any = ({ xs, sm, md, lg, xl, className, children, ...props }: any) => (
  <div className={_cx(_colCls({ xs, sm, md, lg, xl }), className)} {...props}>
    {children}
  </div>
);
const _btnVariantMap: Record<string, any> = {
  primary: 'default',
  secondary: 'outline',
  danger: 'destructive',
  light: 'outline',
  link: 'link',
};
const _Unused_Button: any = ({ variant, size, className, children, ...props }: any) => {
  let mapped = variant;
  if (typeof variant === 'string') {
    if (variant.startsWith('outline-')) mapped = 'outline';
    else if (_btnVariantMap[variant]) mapped = _btnVariantMap[variant];
    else if (variant.startsWith('btn ')) mapped = 'default';
  }
  return (
    <_ShadButton variant={mapped} size={size} className={className} {...props}>
      {children}
    </_ShadButton>
  );
};
const _Unused_Card: any = ({ className, children, ...props }: any) => (
  <ShadCard className={className} {...props}>
    {children}
  </ShadCard>
);
_Unused_Card.Header = ({ className, children, ...props }: any) => (
  <div className={_cx('card-header', className)} {...props}>
    {children}
  </div>
);
_Unused_Card.Body = ({ className, children, ...props }: any) => (
  <div className={_cx('card-body', className)} {...props}>
    {children}
  </div>
);
_Unused_Card.Title = ({ as: As = 'h5', className, children, ...props }: any) => (
  <As className={_cx('card-title', className)} {...props}>
    {children}
  </As>
);
_Unused_Card.Text = ({ className, children, ...props }: any) => (
  <p className={_cx('card-text', className)} {...props}>
    {children}
  </p>
);
_Unused_Card.Footer = ({ className, children, ...props }: any) => (
  <div className={_cx('card-footer', className)} {...props}>
    {children}
  </div>
);
const Form: any = ({ children, onSubmit, className, ...props }: any) => (
  <form
    className={className}
    onSubmit={onSubmit || ((e: any) => e.preventDefault())}
    {...props}
  >
    {children}
  </form>
);
Form.Group = ({ className, controlId: _c, children, ...props }: any) => (
  <div className={_cx('mb-3', className)} {...props}>
    {children}
  </div>
);
Form.Label = ({ className, children, htmlFor, ...props }: any) => (
  <label className={_cx('form-label', className)} htmlFor={htmlFor} {...props}>
    {children}
  </label>
);
Form.Control = ({ as, className, children, isInvalid, ...props }: any) => {
  const cls = _cx('form-control', isInvalid && 'is-invalid', className);
  if (as === 'select')
    return (
      <select className={cls} {...props}>
        {children}
      </select>
    );
  if (as === 'textarea') return <textarea className={cls} {...props} />;
  return <input className={cls} {...props} />;
};
Form.Select = ({ className, children, isInvalid, ...props }: any) => (
  <select
    className={_cx('form-control form-select', isInvalid && 'is-invalid', className)}
    {...props}
  >
    {children}
  </select>
);
Form.Check = ({
  type = 'checkbox',
  label,
  id,
  className,
  inline,
  children,
  ...props
}: any) => (
  <div className={_cx('form-check', inline && 'form-check-inline', className)}>
    <input type={type} id={id} className="form-check-input" {...props} />
    {label !== undefined && (
      <label htmlFor={id} className="form-check-label">
        {label}
      </label>
    )}
    {children}
  </div>
);
Form.Text = ({ muted, className, children, ...props }: any) => (
  <small className={_cx('form-text', muted && 'text-muted', className)} {...props}>
    {children}
  </small>
);
const Modal: any = ({ show, onHide, size, centered: _c, children, className, ...props }: any) => {
  const sizeCls =
    size === 'sm'
      ? 'sm:max-w-md'
      : size === 'lg'
      ? 'sm:max-w-2xl'
      : size === 'xl'
      ? 'sm:max-w-6xl'
      : '';
  return (
    <Dialog open={!!show} onOpenChange={(o: boolean) => !o && onHide?.()}>
      <DialogContent
        className={`${sizeCls} max-h-[90vh] overflow-y-auto ${className || ''}`.trim()}
        {...props}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};
Modal.Header = ({ children, closeButton: _cb, className, ...props }: any) => (
  <DialogHeader className={className} {...props}>
    {children}
  </DialogHeader>
);
Modal.Title = ({ children, className, ...props }: any) => (
  <DialogTitle className={className} {...props}>
    {children}
  </DialogTitle>
);
Modal.Body = ({ children, className, ...props }: any) => (
  <div className={`overflow-x-auto ${className || ''}`.trim()} {...props}>
    {children}
  </div>
);
Modal.Footer = ({ children, className, ...props }: any) => (
  <DialogFooter className={className} {...props}>
    {children}
  </DialogFooter>
);
const Table: any = ({
  bordered,
  striped,
  hover,
  responsive: _r,
  className,
  children,
  ...props
}: any) => (
  <table
    className={_cx(
      'table',
      bordered && 'table-bordered',
      striped && 'table-striped',
      hover && 'table-hover',
      className,
    )}
    {...props}
  >
    {children}
  </table>
);
const _TabsCtx = React.createContext<any>({});
const Tabs: any = ({
  activeKey,
  defaultActiveKey,
  onSelect,
  children,
  className,
  ...props
}: any) => {
  const [internalKey, setInternalKey] = React.useState(defaultActiveKey || null);
  const current = activeKey !== undefined ? activeKey : internalKey;
  const handle = (k: any) => {
    if (activeKey === undefined) setInternalKey(k);
    onSelect?.(k);
  };
  const tabs = React.Children.toArray(children).filter(Boolean) as any[];
  if (current === null && tabs.length) {
    setInternalKey(tabs[0]?.props?.eventKey);
  }
  return (
    <_TabsCtx.Provider value={{ current, setKey: handle }}>
      <div className={className} {...props}>
        <ul className="nav nav-tabs" role="tablist">
          {tabs.map((t: any) => (
            <li key={t.props.eventKey} className="nav-item" role="presentation">
              <button
                type="button"
                className={_cx('nav-link', current === t.props.eventKey && 'active')}
                onClick={() => handle(t.props.eventKey)}
                disabled={t.props.disabled}
              >
                {t.props.title}
              </button>
            </li>
          ))}
        </ul>
        <div className="tab-content">
          {tabs.map((t: any) => (
            <div
              key={t.props.eventKey}
              className={_cx('tab-pane', current === t.props.eventKey && 'active show')}
              style={{ display: current === t.props.eventKey ? undefined : 'none' }}
            >
              {t.props.children}
            </div>
          ))}
        </div>
      </div>
    </_TabsCtx.Provider>
  );
};
const Tab: any = () => null;
const Tooltip: any = ({ children, id: _id, ...props }: any) => (
  <span {...props}>{children}</span>
);
const OverlayTrigger: any = ({ children, overlay, placement: _p, trigger: _t }: any) => {
  let title = '';
  if (overlay?.props?.children) {
    title =
      typeof overlay.props.children === 'string'
        ? overlay.props.children
        : Array.isArray(overlay.props.children)
          ? overlay.props.children.filter((c: any) => typeof c === 'string').join(' ')
          : '';
  }
  return React.cloneElement(children, { title });
};
const Badge: any = ({ bg, pill, className, children, ...props }: any) => (
  <span
    className={_cx('badge', bg && `bg-${bg}`, pill && 'rounded-pill', className)}
    {...props}
  >
    {children}
  </span>
);
const Spinner: any = ({ animation: _a, size, variant, className, ...props }: any) => (
  <span
    className={_cx(
      'spinner-border',
      size === 'sm' && 'spinner-border-sm',
      variant && `text-${variant}`,
      className,
    )}
    role="status"
    aria-hidden="true"
    {...props}
  />
);
import {
  FiUser,
  FiMail,
  FiCalendar,
  FiLock,
  FiShield,
  FiEye,
  FiEyeOff,
  FiInfo,
  FiUserPlus,
  FiTag,
} from 'react-icons/fi';
import {
  clampDateInputValue,
  todayDateInputValue,
  toDateInputValue,
  blockManualDateEntry,
  blockDatePaste,
} from '@/utilities/dateInputHelpers';
import { AvailabilityHint } from '@/hooks/useAvailability';
import { validateEmail, getPasswordValidationErrors, MIN_PASSWORD_LENGTH } from '@/utilities/userCreation';

// Leading decorative icons (user / lock / mail) removed at user request —
// only trailing icons (calendar picker, show-password button, email OTP)
// are still functional-UX and stay. `hasTrailing` still triggers extra
// right-padding on the input so the Show button doesn't overlap the text.
function IconField({ children, hasTrailing, trailingIcon: TrailingIcon }) {
  return (
    <div
      className={`ccf-input-with-icon${hasTrailing ? ' ccf-input-with-icon--trailing' : ''}${
        TrailingIcon ? ' ccf-input-with-icon--icon-right' : ''
      }`}
    >
      {children}
      {TrailingIcon && (
        <span className="ccf-input-with-icon__icon ccf-input-with-icon__icon--right">
          <TrailingIcon size={18} />
        </span>
      )}
    </div>
  );
}

export default function DefaultUserForm({
  isResellerCompany,
  name,
  setName,
  username,
  setUsername,
  email,
  onEmailChange,
  expiryDate,
  setExpiryDate,
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
  showPassword,
  setShowPassword,
  aclValue,
  setAclValue,
  aclList,
  signupEmailOtp,
  setSignupEmailOtp,
  emailVerified,
  signupEmailBusy,
  onSendCode,
  onVerifyOtp,
  emailVerificationRequired = false,
  roleValue,
  setRoleValue,
  roleOptions,
  showAccountType = false,
  accountType = '0',
  setAccountType,
  parentAccountType = null,
  minExpiryDate = todayDateInputValue(),
  maxExpiryDate = null,
  hideExpiry = false,
  companyExpiryNote = null,
  usernameError = '',
  nameError = '',
  usernameTakenMessage = '',
  usernameStatus = 'idle',
  emailStatus = 'idle',
  onUsernameChange,
  onUsernameBlur,
  onNameChange,
  onNameBlur,
}) {
  const emailError = email.trim() ? validateEmail(email) : null;
  const maxExpiryInput = toDateInputValue(maxExpiryDate);
  const passwordErrors = getPasswordValidationErrors(password);
  const hasConfirmPassword = confirmPassword.trim().length > 0;
  const passwordsMatch = password === confirmPassword;

  return (
    <section className="default-user-panel">
      <div className="default-user-panel__header">
        <span className="default-user-panel__header-icon">
          <FiUser size={22} />
        </span>
        <div>
          <h5 className="default-user-panel__title">Default User</h5>
          <p className="default-user-panel__subtitle">
            Switch to this account from the company list.
          </p>
        </div>
      </div>
      <hr className="default-user-panel__divider" />

      <div className="row g-3 default-user-panel__fields">
        <Form.Group className="col-12 col-lg-4 form-group mb-0">
          <Form.Label>
            Full Name <span className="text-danger">*</span>
          </Form.Label>
          <IconField icon={FiUser}>
            <Form.Control
              className={`ccf-input-with-icon__control${nameError ? ' is-invalid' : ''}`}
              placeholder="Full name"
              value={name}
              onChange={onNameChange || ((e) => setName(e.target.value))}
              onBlur={onNameBlur}
              maxLength={100}
            />
          </IconField>
          {nameError ? <div className="invalid-feedback d-block">{nameError}</div> : null}
        </Form.Group>

        <Form.Group className="col-12 col-lg-4 form-group mb-0">
          <Form.Label>
            Username <span className="text-danger">*</span>
          </Form.Label>
          <IconField icon={FiUser}>
            <Form.Control
              className={`ccf-input-with-icon__control${usernameError ? ' is-invalid' : ''}`}
              placeholder="Username"
              value={username}
              onChange={onUsernameChange || ((e) => setUsername(e.target.value))}
              onBlur={onUsernameBlur}
              maxLength={50}
              autoComplete="off"
            />
          </IconField>
          {usernameError ? <div className="invalid-feedback d-block">{usernameError}</div> : null}
          {usernameTakenMessage ? (
            <small className="text-danger">{usernameTakenMessage}</small>
          ) : null}
          {!usernameTakenMessage && !usernameError ? (
            <AvailabilityHint status={usernameStatus} takenMessage="Username already exists" />
          ) : null}
        </Form.Group>

        <Form.Group className="col-12 col-lg-4 form-group mb-0">
          <Form.Label>Expiry Date</Form.Label>
          {hideExpiry ? (
            <div className="ccf-input-with-icon">
              <CalendarDateInput
                className="ccf-input-with-icon__control ccf-input-with-icon__control--date"
                value={expiryDate}
                onChange={() => {}}
                disabled
              />
            </div>
          ) : (
            <IconField trailingIcon={FiCalendar}>
              <CalendarDateInput
                value={expiryDate}
                onChange={(e) =>
                  setExpiryDate(
                    clampDateInputValue(e, minExpiryDate, maxExpiryInput || null),
                  )
                }
                min={minExpiryDate}
                max={maxExpiryInput || undefined}
                className="ccf-input-with-icon__control ccf-input-with-icon__control--date"
              />
            </IconField>
          )}
          {hideExpiry && (
            <small className="text-muted d-block mt-1">
              {companyExpiryNote || "This user's expiry will be the same as the company's expiry."}
            </small>
          )}
        </Form.Group>

        <Form.Group className="col-12 col-lg-4 form-group mb-0">
          <Form.Label>
            Password <span className="text-danger">*</span>
          </Form.Label>
          <IconField icon={FiLock} hasTrailing>
            <Form.Control
              type={showPassword ? 'text' : 'password'}
              className="ccf-input-with-icon__control ccf-input-with-icon__control--trailing"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              className="ccf-input-with-icon__trailing-btn"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
              <span className="ms-1">Show</span>
            </button>
          </IconField>
          <p className="user-create-form__field-hint mb-0">{`Password must be at least ${MIN_PASSWORD_LENGTH} characters.`}</p>
          {password.trim() && passwordErrors.length > 0 ? (
            <div className="user-create-form__password-hints">
              {passwordErrors.map((err) => (
                <div key={err}>- {err}</div>
              ))}
            </div>
          ) : null}
        </Form.Group>

        <Form.Group className="col-12 col-lg-4 form-group mb-0">
          <Form.Label>
            Confirm Password <span className="text-danger">*</span>
          </Form.Label>
          <IconField icon={FiLock}>
            <Form.Control
              type="password"
              className="ccf-input-with-icon__control"
              placeholder="Confirm password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </IconField>
          {hasConfirmPassword ? (
            <small className={passwordsMatch ? 'text-success' : 'text-danger'}>
              {passwordsMatch ? 'Passwords match' : '– Passwords do not match'}
            </small>
          ) : null}
        </Form.Group>

        <Form.Group className="col-12 col-lg-4 form-group mb-0 default-user-panel__role-col">
          <Form.Label>
            Role <span className="text-danger">*</span>
          </Form.Label>
          <IconField icon={FiUserPlus}>
            <Form.Select
              required
              className="ccf-input-with-icon__control ccf-input-with-icon__select ccf-input-with-icon__select--acl"
              value={roleValue}
              onChange={(e) => setRoleValue(e.target.value)}
            >
              {roleOptions.length === 0 ? (
                <option value="">No roles available</option>
              ) : (
                roleOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))
              )}
            </Form.Select>
          </IconField>
        </Form.Group>

        {showAccountType && setAccountType && (
          <Form.Group className="col-12 col-lg-4 form-group mb-0">
            <Form.Label>
              Account Type <span className="text-danger">*</span>
            </Form.Label>
            <IconField icon={FiTag}>
              <Form.Select
                id="defaultUserAccountType"
                required
                className={`ccf-input-with-icon__control ccf-input-with-icon__select${
                  accountType === '' ? ' is-invalid' : ''
                }`}
                value={accountType}
                onChange={(e) => setAccountType(e.target.value)}
              >
                <option value="">Select Account Type</option>
                {parentAccountType === null || parentAccountType === undefined ? (
                  <>
                    <option value="0">Promotional</option>
                    <option value="1">Transactional</option>
                  </>
                ) : Number(parentAccountType) === 0 ? (
                  <option value="0">Promotional</option>
                ) : (
                  <option value="1">Transactional</option>
                )}
              </Form.Select>
            </IconField>
            <p className="user-create-form__field-hint mb-0">
              Promotional or transactional account for the default user.
            </p>
          </Form.Group>
        )}

        <Form.Group className="col-12 col-lg-8 form-group mb-0 default-user-panel__email-col">
          <Form.Label>
            Email <span className="text-danger">*</span>
          </Form.Label>
          <IconField icon={FiMail}>
            <Form.Control
              type="email"
              className={`ccf-input-with-icon__control${
                emailVerificationRequired && emailVerified ? ' is-verified-email' : ''
              }${emailError ? ' is-invalid' : ''}`}
              placeholder="Email"
              value={email}
              onChange={onEmailChange}
              maxLength={100}
            />
          </IconField>
          {emailError ? <div className="invalid-feedback d-block">{emailError}</div> : null}
          {!emailError ? (
            <AvailabilityHint status={emailStatus} takenMessage="Email already exists" />
          ) : null}
          {emailVerificationRequired && (
            <div className="default-user-email-verify">
              {emailVerified ? (
                <span className="text-success small default-user-email-verify__ok">
                  Email verified
                </span>
              ) : (
                <>
                  <Form.Control
                    type="text"
                    inputMode="numeric"
                    className="default-user-email-verify__otp"
                    placeholder="6-digit code"
                    maxLength={6}
                    value={signupEmailOtp}
                    onChange={(e) =>
                      setSignupEmailOtp(e.target.value.replace(/\D/g, '').slice(0, 6))
                    }
                    disabled={signupEmailBusy}
                  />
                  <Button
                    type="button"
                    variant="outline-primary"
                    size="sm"
                    className="default-user-email-verify__btn default-user-email-verify__btn--send"
                    disabled={signupEmailBusy || !email.trim() || !!emailError}
                    onClick={onSendCode}
                  >
                    Send code
                  </Button>
                  <Button
                    type="button"
                    variant="outline-success"
                    size="sm"
                    className="default-user-email-verify__btn default-user-email-verify__btn--verify"
                    disabled={signupEmailBusy || signupEmailOtp.length !== 6}
                    onClick={onVerifyOtp}
                  >
                    Verify OTP
                  </Button>
                </>
              )}
            </div>
          )}
        </Form.Group>
      </div>

      <div className="row user-create-form__row">
        <Form.Group className="col-12 col-lg-4 form-group mb-0 default-user-panel__acl-col">
          <Form.Label>
            ACL Settings <span className="text-danger">*</span>
          </Form.Label>
          <IconField icon={FiShield}>
            <Form.Select
              className="ccf-input-with-icon__control ccf-input-with-icon__select ccf-input-with-icon__select--acl"
              value={aclValue}
              onChange={(e) => setAclValue(e.target.value)}
            >
              <option value="">Select ACL</option>
              {aclList.map((acl) => (
                <option key={acl.id} value={acl.id}>
                  {acl.acl_name}
                  {acl.default_for_role === roleValue ? ' (Default)' : ''}
                </option>
              ))}
            </Form.Select>
          </IconField>
        </Form.Group>
      </div>

      <div className="default-user-panel__info-banner">
        <span className="default-user-panel__info-icon-wrap" aria-hidden>
          <FiInfo size={16} />
        </span>
        <span>
          Review the default user details before submitting. Access and permissions depend on the
          selected role and ACL.
        </span>
      </div>
    </section>
  );
}
